export default {
  'talk.title': 'Group Information',
  'talk.btn.add': 'Add Group',
  'talk.btn.guard': 'Download Guard',
  'talk.table.name': 'Group Name',
  'talk.input.name': 'Please input group name',
  'talk.download.nodata':
    'There is no device to download. Please enter the device before downloading the data',
};
